import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Leaf } from 'lucide-react';

interface EnvironmentalImpactCardProps {
  co2AvoidedKg: number;
  treesEquivalent: number;
  selfConsumptionPct: number;
}

export function EnvironmentalImpactCard({ co2AvoidedKg, treesEquivalent, selfConsumptionPct }: EnvironmentalImpactCardProps) {
  return (
    <Card className="bg-wt-bg-secondary border-border">
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-medium text-muted-foreground flex items-center gap-2">
          <Leaf className="w-4 h-4 text-wt-green-primary" />
          Environmental Impact
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <div className="grid grid-cols-2 gap-4">
          <div>
            <p className="text-muted-foreground text-sm">CO2 Avoided</p>
            <p className="font-mono text-xl font-semibold text-foreground">{co2AvoidedKg.toFixed(0)} kg</p>
          </div>
          <div>
            <p className="text-muted-foreground text-sm">Grid Independence</p>
            <p className="font-mono text-xl font-semibold text-foreground">{selfConsumptionPct.toFixed(0)}%</p>
          </div>
        </div>

        {treesEquivalent >= 0.1 && (
          <p className="text-xs text-muted-foreground">
            Equivalent to <span className="font-mono">{treesEquivalent.toFixed(1)}</span> tree{treesEquivalent >= 1.5 ? 's' : ''} planted (EPA estimate)
          </p>
        )}
      </CardContent>
    </Card>
  );
}
